<template>
  <table :id="id" class="table table-bordered table-striped">
    <slot></slot>
  </table>
</template>

<script>
import 'datatables.net/js/dataTables.min.js';
import 'datatables.net-bs4/js/dataTables.bootstrap4.min.js';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import 'datatables.net-searchbuilder/js/dataTables.searchBuilder.js';
import 'datatables.net-searchbuilder-bs4/js/searchBuilder.bootstrap4.min.js';
import 'datatables.net-searchbuilder-bs4/css/searchBuilder.bootstrap4.min.css';
import 'datatables.net-responsive/js/dataTables.responsive.min.js';
import 'datatables.net-responsive-bs4/js/responsive.bootstrap4.min.js';
import 'datatables.net-responsive-bs4/css/responsive.bootstrap4.min.css';
import 'datatables.net-buttons/js/dataTables.buttons.min.js';
import 'datatables.net-buttons-bs4/js/buttons.bootstrap4.min.js';
import 'datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css';
import 'datatables.net-datetime/dist/dataTables.dateTime.min.js';
import 'datatables.net-datetime/dist/dataTables.dateTime.min.css';
import 'jszip/dist/jszip.min.js';
import pdfMake from 'pdfmake/build/pdfmake.min.js';
import vfsFonts from 'pdfmake/build/vfs_fonts.js';
import 'datatables.net-buttons/js/buttons.html5.min.js';
import 'datatables.net-buttons/js/buttons.print.min.js';
import 'datatables.net-buttons/js/buttons.colVis.min.js';
import moment from 'moment';
import 'moment/locale/pt-br';  

import store from '@/store';

export default {
  props: ['options', 'id'],
  mounted: function() {
    const {vfs} = vfsFonts.pdfMake;
    pdfMake.vfs = vfs;

    $.extend(true, $.fn.dataTable.defaults, {
        "processing": false,
        "serverSide": true,
        "autoWidth": false,
        "stateSave": false,
        "stateSaveCallback": function(settings, data) {
            localStorage.setItem(location, JSON.stringify(data));
        },
        "stateLoadCallback": function() {
            return JSON.parse(localStorage.getItem(location));
        },
        "pageLength": 50,
        "pagingType": "simple_numbers",
        "lengthMenu": [[10,25,50,100, 100000], [10,25,50, 100, "Todos"]],
        "order": [[0, "asc"]],
        "lengthChange": true,
        "ajax": {
          "type": "POST",
          "contentType": "application/json; charset=utf-8",
          "dataType": "json",
            "headers": {
                "Authorization": 'Bearer ' + store.state.token
            }
        },
        dom: 'Bfrtip',
        responsive: true,
        buttons: [
            {
                extend: 'pageLength',
                titleAttr: 'Registros por página',
                text: '<i class="fas fa-list-ol"></i>'
            },
            {
                extend: 'colvis',
                titleAttr: 'Visibilidade',
                columns: 'th:not(:empty):not(.text-center)',
                text: '<i class="far fa-eye"></i>',
            },
            {
                extend: 'csv',
                titleAttr: 'Exportar para o Excel',
                text: '<i class="far fa-file-excel"></i>',
                fieldSeparator: ";",
                charset: 'utf-8',
                bom: true,
                title: (this.options.title) ? this.options.title : null,
                exportOptions: {
                    columns: ':not(:last-child)'
                }
            },
            {
                extend: 'pdf',
                titleAttr: 'Exportar para PDF',
                text: '<i class="fas fa-file-pdf"></i>',
                title: (this.options.title) ? this.options.title : null,
                exportOptions: {
                    columns: ':visible:not(:last-child)'
                }
            },
            {
                extend: 'print',
                titleAttr: 'Imprimir',
                text: '<i class="fas fa-print"></i>',
                title: (this.options.title) ? this.options.title : null,
                exportOptions: {
                    columns: ':visible:not(:last-child)'
                }
            }
        ],
        language: {
            "thousands": '.',
            "decimal": ',',
            "sEmptyTable": "Nenhum registro encontrado",
            "sInfo": "Exibindo de _START_ até _END_ de um total de _TOTAL_ registros",
            "sInfoEmpty": "Exibindo de 0 até 0 de um total de 0 registros",
            "sInfoFiltered": "(filtrado de um total de _MAX_ registros)",
            "sInfoPostFix": "",
            "sInfoThousands": "",
            "sLengthMenu": "Exibir _MENU_ registros por página",
            "sLoadingRecords": "<i class='fa fa-spinner fa-pulse fa-fw'></i> carregando...",
            "sProcessing": "<i class='fa fa-spinner fa-pulse fa-fw'></i> carregando...",
            "sZeroRecords": "Nenhum registro encontrado",
            "sSearch": "Busca",
            "oPaginate": {
                "sNext": "<i class='fa fa-angle-right'></i>",
                "sPrevious": "<i class='fa fa-angle-left'></i>",
                "sFirst": "Primeira",
                "sLast": "Última"
            },
            "oAria": {
                "sSortAscending": ": Ordenar colunas de forma ascendente",
                "sSortDescending": ": Ordenar colunas de forma descendente"
            },
            "select": {
                "rows": {
                    "_": "Selecionado %d linhas",
                    "0": "Nenhuma linha selecionada",
                    "1": "Selecionado 1 linha"
                }
            },
            "searchBuilder": {
                add: '<i class="fas fa-filter"></i> Adicionar Filtro',
                button: {
                    0: '<i class="fas fa-search"></i> Busca Avançada',
                    _: '<i class="fas fa-search"></i> Busca Avançada (%d)'
                },
                clearAll: '<i class="fas fa-sync-alt"></i> Limpar Busca',
                condition: 'Comparador',
                conditions: {
                    array: {
                    contains: 'Contém',
                    empty: 'Vazio',
                    equals: 'Igual a',
                    not: 'Diferente de',
                    notEmpty: 'Não Vazio',
                    without: 'Sem'
                },
                date: {
                    after: 'Depois de',
                    before: 'Antes de',
                    between: 'Entre',
                    empty: 'Vazio',
                    equals: 'Igual a',
                    not: 'Diferente de',
                    notBetween: 'Não Entre',
                    notEmpty: 'Não Vazio'
                },
                number: {
                    between: 'Entre',
                    empty: 'Vazio',
                    equals: 'Igual a',
                    gt: 'Maior que',
                    gte: 'Maior ou Igual a',
                    lt: 'Menor que',
                    lte: 'Menor ou Igual a',
                    not: 'Diferente de',
                    notBetween: 'Não Entre',
                    notEmpty: 'Não Vazio'
                },
                string: {
                    contains: 'Contém',
                    empty: 'Vazio',
                    endsWith: 'Termina com',
                    equals: 'Igual a',
                    not: 'Diferente de',
                    notContains: 'Não Contém',
                    notEmpty: 'Não Vazio',
                    notEndsWith: 'Não Termina com',
                    notStartsWith: 'Não Começa com',
                    startsWith: 'Começa com'
                }

                },
                data: 'Selecione o Campo',
                "delete": '<i class="fas fa-trash-alt"></i>',
                deleteTitle: '',
                left: '<i class="fas fa-angle-double-left"></i>',
                leftTitle: '',
                logicAnd: 'AND',
                logicOr: 'OR',
                right: '<i class="fas fa-angle-double-right"></i>',
                rightTitle: 'Indent criteria',
                search: '<i class="fas fa-search"></i> Buscar',
                title: {
                    0: '<i class="fas fa-search"></i> Busca Avançada',
                    _: '<i class="fas fa-search"></i> Busca Avançada (%d)'
                },
                value: 'Selecione uma Opção',
                valueJoiner: 'até'
            }
        }
    });

    if(this.options.ajax)
    {
        this.options.ajax.url = process.env.VUE_APP_BASE_API + this.options.ajax.url;
    }

    if(this.options.searchBuilder)
    {
        var api_url = process.env.VUE_APP_BASE_API + this.options.searchBuilder.url;
        var params = this.options.searchBuilder.params;

        this.options.ajax = function(data, callback) {
            $.ajax({
                url: api_url,
                type: 'POST',
                contentType: 'application/json',
                "headers": {
                    "Authorization": 'Bearer ' + store.state.token
                },
                data: JSON.stringify($.extend({}, data, { params })),
                success: function(response) {
                    callback(response);
                }
            });
        }
        this.options.dom = 'QBfrtip';

        window.moment = moment;
        window.moment.locale('pt-br');

        $.fn.dataTable.DateTime.defaults.i18n = {
            "clear": "Limpar",
            "previous": "Anterior",
            "next": "Próximo",
            "months": [
                "Janeiro",
                "Fevereiro",
                "Março",
                "Abril",
                "Maio",
                "Junho",
                "Julho",
                "Agosto",
                "Setembro",
                "Outubro",
                "Novembro",
                "Dezembro"
            ],
            "weekdays": [
                "Dom",
                "Seg",
                "Ter",
                "Qua",
                "Qui",
                "Sex",
                "Sáb"
            ],
            "amPm": [
                "AM",
                "PM"
            ],
            "hours": "Hora",
            "minutes": "Minuto",
            "seconds": "Segundo",
            "unknown": "-",
            "today": "Hoje"
        };
    }

    $(this.$el).DataTable(this.options);
    $(this.$el).on('processing.dt', function (e, settings, processing) {
        if (processing) {
            $('.overlay').show();
        } else {
            $('.overlay').hide();
        }
    });
  },
  destroyed: function () {
    $(this.$el).DataTable().destroy();
  },
   methods: {
    reload() {
      $(this.$el).DataTable().draw();
    }
  }
};
</script>

<style>
.dt-buttons {
    margin-top: 10px;
    float: left; /* Alinha os botões à esquerda */
    margin-bottom: 10px; /* Adiciona espaço inferior */
}

.dt-search {
    margin-top: 10px;
    float: right; /* Alinha o campo de busca à direita */
    margin-bottom: 10px; /* Adiciona espaço inferior */
}

.dt-info {
    margin-top: 10px; /* Adiciona espaço superior */
}

.dt-paging ul.pagination, .dt-paging nav {
    justify-content: flex-end !important;
    margin-top: 10px; /* Adiciona espaço superior */
    display: flex;
}

.dt-paging span.ellipsis {
  align-self: center;
  padding: 0px !important;
}

button.dtsb-search {
  float: none !important;
  margin-left: 6px;
}
</style>